import keyBy from 'lodash/keyBy';
import {
	QUICK_DATE_FILTER_ALL_TIME,
	QUICK_DATE_FILTER_CUSTOM,
	QUICK_DATE_FILTER_PAST_2_WEEKS,
	QUICK_DATE_FILTER_PAST_3_MONTHS,
	QUICK_DATE_FILTER_PAST_6_MONTHS,
	QUICK_DATE_FILTER_PAST_MONTH,
	QUICK_DATE_FILTER_PAST_WEEK,
} from '../../common/constants';
import type { QUICK_DATE_OPTION } from './types';

export const QUICK_DATE_FILTER_OPTIONS: QUICK_DATE_OPTION[] = [
	{ label: 'Past Week', value: QUICK_DATE_FILTER_PAST_WEEK },
	{ label: 'Past 2 Weeks', value: QUICK_DATE_FILTER_PAST_2_WEEKS },
	{ label: 'Past Month', value: QUICK_DATE_FILTER_PAST_MONTH },
	{ label: 'Past 3 Months', value: QUICK_DATE_FILTER_PAST_3_MONTHS },
	{ label: 'Past 6 Months', value: QUICK_DATE_FILTER_PAST_6_MONTHS },
	{ label: 'All Time', value: QUICK_DATE_FILTER_ALL_TIME },
];

export const QUICK_DATE_FILTER_LABELS: QUICK_DATE_OPTION[] = [
	...QUICK_DATE_FILTER_OPTIONS,
	{ label: 'Custom dates', value: QUICK_DATE_FILTER_CUSTOM },
];

export const QUICK_DATE_FILTER_LABELS_BY_VALUE: {
	[key: string]: QUICK_DATE_OPTION;
} = keyBy(QUICK_DATE_FILTER_LABELS, 'value');
